import {Injectable} from '@angular/core';
import {Work} from './work.model';
import {Service} from '../../common/service.class';
import {UserModelListService} from '../../common/user-model-list.service';
import {Observable} from 'rxjs';
import {GapInfo} from './gap-info.model';

const NAMESPACE = 'work';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class WorkService extends UserModelListService<Work> {

    private readonly _service: Service;

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, NAMESPACE, Work);
        this._service = new Service(svcm, NAMESPACE);
    }

    doHistoryGapsExist(): Observable<boolean> {
        return this._service.getScalarValue('historyGapsExist', this._modelType);
    }

    entriesAndGapInformation(): Observable<GapInfo> {
        return this._service.get(GapInfo, 'entriesAndGapInformation');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/history/work.service.ts